module.exports = __webpack_public_path__ + "img/borderBubbleWhite.82716c71.svg";